<template lang="html">
  <div id="products-page" data-aos="fade">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h1 class="title-s1">Productos</h1>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Poliestireno en Alto</h5>

            <table class="table table-sm">
              <tbody>
                <tr>
                  <td class="td-1">Serigrafía</td>
                  <td class="td-2"><router-link to="/productos/ps-seri">PS-SERI</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Offset</td>
                  <td class="td-2"><router-link to="/productos/ps-off">PS-OFF</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Termoformado</td>
                  <td class="td-2"><router-link to="/productos/ps-ter">PS-TER</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Medidas estándar</td>
                  <td class="td-2"><router-link to="/productos/ps-std">PS-STD</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Otros Propósitos</td>
                  <td class="td-2">
                    Productos a la medida del cliente, y/o segun requerimientos.
                  </td>
                </tr>
                <tr>
                  <td class="td-1">HIPS ESD</td>
                  <td class="td-2">ESD</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image"  data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/products/product-1.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Polipropileno</h5>

            <table class="table table-sm">
              <tbody>
                <tr>
                  <td class="td-1">Impresión</td>
                  <td class="td-2"><router-link to="/productos/pp-imp">PP-IMP</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Pasta Engargolado</td>
                  <td class="td-2">PP-PASTA</td>
                </tr>
                <tr>
                  <td class="td-1">Grabado</td>
                  <td class="td-2"><router-link to="/productos/pp-grab">PP-GRAB</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Otros propósitos</td>
                  <td class="td-2">
                    Productos a la medida del cliente, y/o según requerimientos.
                  </td>
                </tr>
                <tr>
                  <td class="td-1">Tira de Impulso</td>
                  <td class="td-2"><router-link to="/productos/tira">TIRA</router-link></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image" data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/products/product-2.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Polietileno</h5>

            <table class="table table-sm">
              <tbody>
                <tr>
                  <td class="td-1">Serigrafía</td>
                  <td class="td-2"><router-link to="/productos/ps-seri">PS-SERI</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Offset</td>
                  <td class="td-2"><router-link to="/productos/ps-off">PS-OFF</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Termoformado</td>
                  <td class="td-2"><router-link to="/productos/ps-ter">PS-TER</router-link></td>
                </tr>
                <tr>
                  <td class="td-1">Otros Propositos</td>
                  <td class="td-2">
                    Productos a la medida del cliente, y/o segun requerimientos.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image" data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/products/product-3.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
